import { EtDatetime } from 'abushakir';

// Ethiopian month names in Amharic and Oromiffa
export const ethiopianMonths = {
  am: [
    'መስከረም', 'ጥቅምት', 'ህዳር', 'ታህሳስ', 'ጥር', 'የካቲት',
    'መጋቢት', 'ሚያዚያ', 'ግንቦት', 'ሰኔ', 'ሐምሌ', 'ነሐሴ', 'ጳጉሜ'
  ],
  om: [
    'Fulbaana', 'Onkololeessa', 'Sadaasa', 'Muddee', 'Amajjii', 'Guraandhala',
    'Bitootessa', 'Ebla', 'Caamsaa', 'Waxabajjii', 'Adoolessa', 'Hagayya', 'Qaammee'
  ]
};

// Convert Ethiopian date to Gregorian date
export const ethiopianToGregorian = (year, month, day) => {
  const etDate = new EtDatetime(year, month, day);
  return new Date(etDate.moment);
};

// Convert Gregorian date to Ethiopian date
export const gregorianToEthiopian = (date) => {
  const etDate = new EtDatetime(date.getTime());
  return {
    year: etDate.year,
    month: etDate.month,
    day: etDate.day
  };
};

// Format date string based on locale
export const formatDate = (dateString, lang, includeTime = false) => {
  const date = new Date(dateString);
  
  // Convert to Ethiopian calendar for Amharic and Oromiffa
  if (lang === 'am' || lang === 'om') {
    const ethiopianDate = new EtDatetime(date.getTime());
    const monthName = ethiopianMonths[lang][ethiopianDate.month - 1];
    
    if (includeTime) {
      // Format time in 12-hour format
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? (lang === 'am' ? 'ከሰዓት' : 'WB') : (lang === 'am' ? 'ጥዋት' : 'WD');
      const hour12 = hours % 12 || 12;
      const formattedTime = `${hour12}:${minutes.toString().padStart(2, '0')}`;

      if (lang === 'am') {
        return `${monthName} ${ethiopianDate.day}፣ ${ethiopianDate.year} ${formattedTime} ${ampm}`;
      } else {
        return `${monthName} ${ethiopianDate.day}, ${ethiopianDate.year} at ${formattedTime} ${ampm}`;
      }
    } else {
      // Date only format
      if (lang === 'am') {
        return `${monthName} ${ethiopianDate.day}፣ ${ethiopianDate.year}`;
      } else {
        return `${monthName} ${ethiopianDate.day}, ${ethiopianDate.year}`;
      }
    }
  }
  
  // Use regular Gregorian calendar for English
  const options = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    ...(includeTime && {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
  };
  
  return date.toLocaleDateString('en-US', options);
};
